
const _isVisible = (elem: HTMLElement): boolean => {
  if (!elem) {
    return false;
  }
  return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
};

export const isVisible = (elem: string | HTMLElement): boolean => {
  if (typeof elem === 'string') {
    return _isVisible(document.querySelector(elem) as HTMLElement);
  } else {
    return _isVisible(elem);
  }
}